export const authActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
};
